import configurationService from '../services/configurationService';

export const attachmentDownloadUrl = (
  prospectId: string,
  attachmentId: string,
) => {
  const prefix = configurationService.isLocalDev()
    ? 'http://localhost:3000'
    : '';
  return `${prefix}/api/v2/prospectAttachment/getAttachment?prospectID=${prospectId}&attachmentID=${attachmentId}`;
};

export const attachmentPreviewUrl = (
  prospectId: string,
  attachmentId: string,
) => {
  const prefix = configurationService.isLocalDev()
    ? 'http://localhost:3000'
    : '';
  return `${prefix}/api/v2/prospectAttachment/getAttachmentFile?prospectId=${prospectId}&attachmentId=${attachmentId}&preview=true`;
};
